import React from 'react'
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
function TermsConditionsExpenseTracker() {
  return (
    <>
   
     <div className="about-page">
      <div className="container">
        <h1>Terms and Conditions</h1>
        <p>Effective Date: 8th May 2026</p>
        <p className="intro">
          Welcome to <strong>Expense Tracker</strong>, a personal finance
          application operated by{" "}
          <strong>Innosutra AI Private Limited</strong> ("Company", "we", "our",
          or "us").
        </p>
        <p>
          By accessing or using our mobile application "Expense Tracker" or any
          related services (collectively, the "Service"), you agree to comply
          with and be bound by these Terms and Conditions ("Terms"). If you do
          not agree, please do not use the Service.
        </p>
        <p>
          These Terms form part of our agreement with you and should be read
          together with our <strong>Privacy Policy</strong>, which explains how
          we collect, use, and protect your information. Undefined capitalized
          terms used in these Terms have the meanings given to them in the
          Privacy Policy.
        </p>

        <section className="section">
          <h2>1. Definitions</h2>
          <ul>
            <li>
              <strong>"User"</strong>, <strong>"You"</strong>,{" "}
              <strong>"Your"</strong> refers to any individual accessing or
              using the Service.
            </li>
            <li>
              <strong>"Company"</strong>, <strong>"We"</strong>,{" "}
              <strong>"Us"</strong>, <strong>"Our"</strong> refers to
              Innosutra AI Private Limited.
            </li>
            <li>
              <strong>"Service"</strong> refers to the Expense Tracker mobile
              application and all features, content, and functionalities
              provided through it.
            </li>
            <li>
              <strong>"Content"</strong> refers to all text, graphics, logos,
              software, and other materials made available through the Service.
            </li>
            <li>
              <strong>"Profile"</strong> refers to a separate sub-account
              within your account that maintains its own name, optional
              icon/photo, and financial data.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>2. Acceptance of Terms</h2>
          <ul>
            <li>
              By using the Service, you confirm that you are legally capable of
              entering into a binding agreement and that you are at least 18
              years of age.
            </li>
            <li>
              You agree to comply with all applicable laws and these Terms.
            </li>
            <li>
              If you do not agree to these Terms, you must not access or use the
              Service.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>3. Description of Service</h2>
          <p>Expense Tracker is a personal finance app that helps you:</p>
          <ul>
            <li>Record expenses, income, and investments</li>
            <li>Plan budgets and savings goals</li>
            <li>Track recurring bills and reminders</li>
            <li>Keep reminders of money you owe or are owed</li>
            <li>
              Maintain multiple profiles (for example, to track a family
              member's finances separately)
            </li>
            <li>
              Optionally detect transactions from SMS (with your permission)
            </li>
            <li>Optionally use biometric app lock and voice entry</li>
          </ul>
          <p>
            The Service is provided for personal, non-commercial use only unless
            otherwise authorized by us in writing.
          </p>
        </section>

        <section className="section">
          <h2>4. Account Registration and Security</h2>
          <ul>
            <li>
              You must create an account to use the Service. You agree to
              provide accurate, current, and complete information during
              registration.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account credentials (email and password).
            </li>
            <li>
              You are responsible for all activities that occur under your
              account.
            </li>
            <li>
              You must notify us immediately of any unauthorized use of your
              account or any other breach of security.
            </li>
            <li>
              We store passwords in encrypted/hashed form and cannot see your
              actual password.
            </li>
            <li>
              You may maintain multiple profiles within one account. Each
              profile is your responsibility, and you must ensure you have the
              right to record financial data for any person whose finances you
              track in a separate profile.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>5. Financial Information You Enter</h2>
          <ul>
            <li>
              You are solely responsible for the accuracy and completeness of
              all financial information you enter into the Service, including
              transactions, categories, budgets, savings goals, recurring
              entries, and money reminders.
            </li>
            <li>
              The Service is a record-keeping and planning tool only. We do not
              provide financial, investment, tax, or legal advice.
            </li>
            <li>
              You should not enter sensitive categories of personal data such as
              government identification numbers, health or medical information,
              or biometric data into note fields or anywhere else in the
              Service.
            </li>
            <li>
              We are not responsible for any financial decisions you make based
              on information displayed in the Service.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>6. SMS Access (Optional, Permission-Based)</h2>
          <ul>
            <li>
              With your explicit permission, the Service can read transactional
              SMS messages (such as bank and UPI payment alerts) already on your
              device to help you record expenses automatically.
            </li>
            <li>
              SMS access is requested only after you opt in from within the app.
              You can decline, and the rest of the Service works without it.
            </li>
            <li>
              Message text is scanned and parsed on your device. We do not
              upload the full text of your SMS messages to our servers.
            </li>
            <li>
              Detected candidates (amount, merchant, date, suggested category)
              are shown to you for review. Nothing is saved to your account
              until you confirm or edit and accept an entry.
            </li>
            <li>
              Only the transaction details you approve — not the original SMS
              content — are stored as a normal expense/income entry in your
              account.
            </li>
            <li>
              You can revoke SMS permission at any time from your device's
              Settings, which stops this feature without affecting the rest of
              the Service.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>7. Biometric App Lock (On-Device Only)</h2>
          <ul>
            <li>
              The Service can use your device's built-in fingerprint, face
              unlock, or screen-lock PIN to optionally lock the app and confirm
              it's you before revealing masked amounts on the dashboard.
            </li>
            <li>
              This authentication is performed entirely by your device's
              operating system.
            </li>
            <li>
              We never receive, see, transmit, or store your fingerprint, face
              data, or any other biometric information — the app only receives a
              yes/no confirmation from the OS.
            </li>
            <li>
              This feature is optional and can be turned off at any time in the
              app's Settings.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>8. Microphone (Voice Entry, Optional)</h2>
          <ul>
            <li>
              If you use the voice-entry shortcut to add an expense by speaking
              instead of typing, the Service uses your device's microphone and
              speech-recognition capability to convert your speech to text.
            </li>
            <li>
              We do not store audio recordings; only the resulting text (and the
              entry you choose to save) is retained.
            </li>
            <li>
              Voice entry is optional and can be disabled at any time in the
              app's Settings.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>9. Push Notifications</h2>
          <ul>
            <li>
              If you enable notifications, we use Firebase Cloud Messaging to
              deliver reminders (such as upcoming bills or recurring entries) to
              your device.
            </li>
            <li>
              This requires storing a device notification token, which is used
              solely to deliver these notifications.
            </li>
            <li>
              You can disable notifications at any time in Settings or your
              device's notification permissions.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>10. Use of Cookies and Similar Technologies</h2>
          <p>We may use cookies and similar technologies to:</p>
          <ul>
            <li>Improve user experience</li>
            <li>Analyze usage patterns</li>
            <li>Enable essential features</li>
          </ul>
          <p>
            By using the Service, you consent to the use of cookies and similar
            technologies in accordance with our Privacy Policy.
          </p>
        </section>

        <section className="section">
          <h2>11. Intellectual Property Rights</h2>
          <p>
            All content on <strong>Expense Tracker</strong>, including but not
            limited to:
          </p>
          <ul>
            <li>Videos</li>
            <li>Graphics</li>
            <li>Text</li>
            <li>Logos</li>
            <li>Software</li>
            <li>User interface designs</li>
            <li>Reports and charts generated by the Service</li>
          </ul>
          <p>
            is owned by or licensed to the Company and protected under
            applicable intellectual property laws.
          </p>
          <p>You agree NOT to:</p>
          <ul>
            <li>Copy, reproduce, or republish content</li>
            <li>Sell, rent, or sublicense content</li>
            <li>Distribute content without permission</li>
            <li>Reverse engineer, decompile, or disassemble the Service</li>
            <li>Modify or create derivative works based on the Service</li>
          </ul>
          <p>
            Content may only be used for personal, non-commercial purposes
            unless otherwise authorized in writing.
          </p>
        </section>

        <section className="section">
          <h2>12. User-Generated Content</h2>
          <p>
            Certain sections of the Service may allow you to enter notes, create
            custom categories, or post content.
          </p>
          <p>By entering content, you confirm:</p>
          <ul>
            <li>You own or have rights to the content</li>
            <li>
              The content does not violate any laws or third-party rights
            </li>
            <li>The content is not offensive, defamatory, or unlawful</li>
          </ul>
          <p>
            You grant the Company a non-exclusive, worldwide, royalty-free
            license to use, reproduce, and distribute your content solely for
            the purpose of providing and improving the Service.
          </p>
          <p>We reserve the right to:</p>
          <ul>
            <li>Monitor user content</li>
            <li>Remove content that violates these Terms</li>
          </ul>
        </section>

        <section className="section">
          <h2>13. Third-Party Services and Links</h2>
          <p>The Service uses third-party services including:</p>
          <ul>
            <li>
              <strong>Razorpay</strong> — subscription billing and payment
              processing
            </li>
            <li>
              <strong>Firebase Cloud Messaging</strong> — delivering push
              notifications
            </li>
            <li>
              <strong>A third-party financial news provider</strong> — to
              display news articles in the app
            </li>
          </ul>
          <p>The Service may also contain links to third-party websites.</p>
          <p>We:</p>
          <ul>
            <li>Do not control or endorse such websites or services</li>
            <li>Are not responsible for their content or practices</li>
            <li>
              Do not share your personal or financial data with the financial
              news provider
            </li>
          </ul>
          <p>
            Users access third-party links and services at their own risk. Each
            provider has its own privacy policy governing how it handles data.
          </p>
        </section>

        <section className="section">
          <h2>14. Subscription and Payments</h2>
          <ul>
            <li>
              Certain features of the Service may require a paid subscription.
            </li>
            <li>
              Subscription payments are handled by Razorpay. We do not store
              your card, UPI, or bank credentials; that information is collected
              and processed directly by Razorpay under its own privacy policy.
            </li>
            <li>
              Subscription fees are non-refundable except as required by
              applicable law.
            </li>
            <li>
              We reserve the right to change subscription fees with reasonable
              notice.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>15. Linking to Our Platform</h2>
          <p>
            Certain organizations may link to our Platform without prior
            approval, including:
          </p>
          <ul>
            <li>Government bodies</li>
            <li>Search engines</li>
            <li>News platforms</li>
          </ul>
          <p>Other entities must obtain prior written permission.</p>
          <p>Approved links must:</p>
          <ul>
            <li>Not be misleading</li>
            <li>Not imply endorsement</li>
            <li>Fit contextually within the linking site</li>
          </ul>
          <p>Use of our logo or branding requires explicit permission.</p>
        </section>

        <section className="section">
          <h2>16. Restrictions on Framing</h2>
          <p>You may not:</p>
          <ul>
            <li>Create frames around our website or app</li>
            <li>Alter the visual presentation of the Service</li>
          </ul>
          <p>without prior written consent.</p>
        </section>

        <section className="section">
          <h2>17. Content Liability</h2>
          <p>We are not responsible for:</p>
          <ul>
            <li>Content published on third-party websites linking to us</li>
            <li>
              Any loss or damage arising from your use of third-party services
            </li>
          </ul>
          <p>
            You agree to defend and indemnify us against claims arising from
            your use of the Service or your violation of these Terms.
          </p>
        </section>

        <section className="section">
          <h2>18. Modification of Terms</h2>
          <p>We reserve the right to:</p>
          <ul>
            <li>Update or modify these Terms at any time</li>
            <li>
              Post the updated Terms within the Service and/or on our website
              with a revised "last updated" date
            </li>
            <li>
              Highlight material changes through an in-app notice where
              practicable
            </li>
          </ul>
          <p>
            Continued use of the Service after changes means you accept the
            revised Terms.
          </p>
        </section>

        <section className="section">
          <h2>19. Removal of Links or Content</h2>
          <p>
            If you find any content or link on our Service objectionable, you
            may contact us.
          </p>
          <p>We may:</p>
          <ul>
            <li>Review such requests</li>
            <li>Remove content at our discretion</li>
          </ul>
          <p>However, we are not obligated to take action.</p>
        </section>

        <section className="section">
          <h2>20. Disclaimer of Warranties</h2>
          <p>
            The Service is provided on an "as is" and "as available" basis.
          </p>
          <p>We do not guarantee:</p>
          <ul>
            <li>Accuracy of information</li>
            <li>Continuous availability</li>
            <li>Error-free operation</li>
            <li>That the Service will meet your specific requirements</li>
          </ul>
          <p>
            We disclaim all warranties, express or implied, including but not
            limited to implied warranties of merchantability, fitness for a
            particular purpose, and non-infringement.
          </p>
        </section>

        <section className="section">
          <h2>21. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, we shall not be liable for:
          </p>
          <ul>
            <li>
              Any indirect, incidental, special, consequential, or punitive
              damages
            </li>
            <li>Loss of data, revenue, or profits</li>
            <li>
              Any loss arising from your reliance on information provided by the
              Service
            </li>
            <li>
              Any unauthorized access to or use of our servers or databases
            </li>
          </ul>
          <p>
            Nothing in these Terms limits liability where it is unlawful to do
            so.
          </p>
        </section>

        <section className="section">
          <h2>22. Data Security</h2>
          <p>
            We use industry-standard safeguards to protect your information,
            including:
          </p>
          <ul>
            <li>
              Encrypted transmission (HTTPS) between the app and our servers
            </li>
            <li>
              Encryption of sensitive financial figures at rest where applicable
            </li>
            <li>Hashed password storage</li>
            <li>Access controls on our systems</li>
          </ul>
          <p>
            No method of transmission or storage is 100% secure, but we work to
            protect your information using commercially reasonable measures.
          </p>
        </section>

        <section className="section">
          <h2>23. Data Retention</h2>
          <p>
            We retain your account and financial data for as long as your
            account remains active, so that the Service can continue to function
            (e.g. showing historical reports). If you delete a specific entry,
            profile, or your account, we delete or anonymize the corresponding
            data within a reasonable period, except where we are required to
            retain it to comply with legal, tax, or accounting obligations.
          </p>
        </section>

        <section className="section">
          <h2>24. Your Rights and Choices</h2>
          <ul>
            <li>
              You can view, edit, or delete individual transactions, categories,
              budgets, goals, bill reminders, money reminders, and profiles at
              any time within the app.
            </li>
            <li>
              You can export your transaction history as a CSV file or a PDF
              report at any time.
            </li>
            <li>
              You can disable SMS access, biometric lock, voice entry, or push
              notifications at any time, without losing access to the rest of
              the Service.
            </li>
            <li>
              You can request a copy of, correction to, or deletion of your
              personal data by contacting us.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>25. Account and Data Deletion</h2>
          <ul>
            <li>
              You can delete individual profiles and data from within the app.
            </li>
            <li>
              To request deletion of your entire account and all associated
              data, email us at{" "}
              <strong>innosutraaiprivatelimited@gmail.com</strong> from your
              registered email address with the subject "Account Deletion
              Request."
            </li>
            <li>
              We will verify your request and delete your account and personal
              data within 30 days, except where we must retain certain records
              to meet legal or regulatory obligations.
            </li>
          </ul>
        </section>

        <section className="section">
          <h2>26. Children's Privacy</h2>
          <p>
            The Service is intended for users who are at least 18 years old. We
            do not knowingly collect personal information from children. If you
            believe a child has provided us with personal information, please
            contact us so we can delete it.
          </p>
        </section>

        <section className="section">
          <h2>27. Governing Law</h2>
          <p>
            These Terms shall be governed by and interpreted in accordance with
            the laws of India.
          </p>
          <p>
            Any disputes arising from these Terms shall be subject to the
            exclusive jurisdiction of the courts located in Thane, Maharashtra,
            India.
          </p>
        </section>

        <section className="section">
          <h2>28. Grievance Officer / Contact Information</h2>
          <p>
            For any questions, concerns, or requests regarding these Terms or
            the Service, you may contact:
          </p>
          <ul>
            <li>
              <strong>Innosutra AI Private Limited</strong>
            </li>
            <li>
              Email:{" "}
              <a href="mailto:innosutraaiprivatelimited@gmail.com">
                innosutraaiprivatelimited@gmail.com
              </a>
            </li>
            <li>Address: Thane, Maharashtra, India</li>
          </ul>
        </section>

        <p className="footer-note">
          <strong>
            By using Expense Tracker, you acknowledge that you have read,
            understood, and agree to be bound by these Terms and Conditions.
          </strong>
        </p>
      </div>
    </div>
  
    </>
  )
}
export default TermsConditionsExpenseTracker